import { Calendar } from 'primereact/calendar'

import { cap } from '../../State'
import { translations } from '../../translations'
import { FieldWrapper } from './FieldWrapper'

const language = cap.language.state || 'IT'
const t = translations[language]

const dateOptions = { year: 'numeric', month: '2-digit', day: '2-digit' }

const parseValue = (value) => {
  if (!value) return null
  const [d, m, y] = String(value).split('/')
  if (!d || !m || !y) return null
  const date = new Date(Number(y), Number(m) - 1, Number(d))
  return Number.isNaN(date.getTime()) ? null : date
}

export const DateField = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  required,
  disabled,
  helper,
  error,
  diffStatus,
  ai = false,
  minDate
}) => (
  <FieldWrapper
    id={id}
    label={label}
    required={required}
    helper={helper}
    error={error}
    diffStatus={diffStatus}
    ai={ai}
    disabled={disabled}
  >
    <Calendar
      inputId={id}
      value={parseValue(value)}
      onChange={(e) => onChange?.(e.value ? e.value.toLocaleDateString('it', dateOptions) : '')}
      onBlur={onBlur}
      disabled={disabled}
      dateFormat="dd/mm/yy"
      showIcon
      placeholder={t.formatoDataPlaceholder}
      minDate={minDate}
      aria-invalid={error ? 'true' : 'false'}
      className={error ? 'p-invalid' : ''}
    />
  </FieldWrapper>
)
